import styled from 'styled-components';

export const Wrapper = styled.div<{
  disabled?: boolean;
  displayBackground?: boolean;
  size: string;
  background?: string;
  hoverBackground?: string;
  hoverColorIcon?: string;
  styles?: any;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.button.icon[props.size]}px;
  height: ${props => props.theme.button.icon[props.size]}px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${props =>
    props.displayBackground
      ? props.background
        ? props.background
        : '#F8F8F8 !important'
      : 'none'};
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  /* transition: background-color 0.2s; */
  /* 
  path {
    fill: ${props => props.theme.colors.text.secondary};
  } */
  ${p => p.disabled && `pointer-events: none;`}
  &:hover {
    background: ${props =>
      props.displayBackground
        ? props.hoverBackground
          ? props.hoverBackground
          : '#FFFFFF !important'
        : 'none'};

    > svg path {
      fill: ${props =>
        props?.hoverColorIcon
          ? props.hoverColorIcon
          : props.theme.colors.primary.main};
    }

    circle,
    path {
      fill: ${props =>
        props?.hoverColorIcon
          ? props.hoverColorIcon
          : props.theme.colors.text.main} !important;
    }

    ${props =>
      props.displayBackground &&
      `&::before {
        content: ' ';
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: ${props.theme.colors.primary.main};
    
        opacity: 0.1;
        pointer-events: auto;
        position: absolute;
        top: 0;
        left: 0;
      }`}
  }
  position: relative;

  ${p => p.styles};
`;
